/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 *
 * @param {string} name The name of the cookie
 * @return {string} The cookie value
 */
export const getCookie = (name) => {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }

    return null;
};

/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 *
 * @param {string} name The name of the cookie
 * @param {string} value The value of the cookie
 * @param {string} days Number of days cookie will expire
 * @return {void} The cookie value
 */
export const setCookie = (name, value, days, expiry = false) => {
    let expires = '';

    if (expiry) {
        expires = '; expires=' + expiry;
    } else {

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toUTCString();
        }
        
    }
    
    document.cookie = `${name}=${value || ''}${expires}; path=/; Secure;`;
};

/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 *
 * @param {string} name The name of the cookie
 * @return {void}
 */
export const deleteCookie = (name) => {
    document.cookie = `${name}=; path=/; Secure; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
